module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_off_4.cde9d6cf.svg";